import { Injectable } from '@angular/core';
import { HttpClient,  } from '@angular/common/http';
import { Observable,  } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/service/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
@Injectable({ providedIn: 'root'})

export class GetComingDueAuthService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public outputValuesAuth(state ,url): void {
    this.getComingDueList(state , url).subscribe(x => super.next(x));
  }
  getComingDueList(state?, url?: string): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>(url, state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }
}
